import { Pipe, PipeTransform } from '@angular/core';
import { ZählerName } from './zaehler.types';
import { Column } from 'src/app/models/ui/table';

@Pipe({
  name: 'filterTolByOptions',
})
export class FilterTolByNameOptionsPipe implements PipeTransform {
  transform(wertColumns: Column[], options: ZählerName): Column[] {
    return wertColumns?.filter(col => {
      if (!options.isSR100 && col.id.toLowerCase().includes('sr100')) return false;
      if (!options.isSRG && col.id.toLowerCase().includes('srg')) return false;
      else return true;
    });
  }
}
